export const ValueTemplate = ({ optionObj, propsObj }) => {
  if (optionObj)
    return (
      <div>
        {optionObj.label}{" "}
        <span>
          (typ pola: <span>{optionObj.type}</span>)
        </span>
      </div>
    );

  return <span>{propsObj.placeholder}</span>;
};
